import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { VersionComponent } from './version.component'
import { versionRoutes } from './version.routing'
import { CardModule } from '@components/card/card.module'
import { PageHeaderModule } from '@components/page-header/page-header.module'

@NgModule({
  declarations: [VersionComponent],
  imports: [
    CommonModule,
    CardModule,
    PageHeaderModule,
    RouterModule.forChild(versionRoutes),
  ],
})
export class VersionModule {}
